import * as node from '../node/index.js';

export default {
    node
};
